<template>
  <div class="w-full">
    <NText class="pr-2" variant="caption1" weight="medium">
      {{
        t('modules.watchlist.delete_watchlist_confirm_message', {
          watchlistName: watchlist.title,
        })
      }}
    </NText>

    <div class="flex items-center justify-center w-full mt-6">
      <NButton
        class="ml-3 flex-1"
        color="gray"
        variant="flat"
        @click="remove()"
      >
        {{ t('common.cancel') }}
      </NButton>

      <NButton
        color="red"
        class="mr-3 flex-1"
        @click="emit('delete', watchlist.id)"
      >
        {{ t('modules.watchlist.delete_watchlist') }}
      </NButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useDialog } from '@negar/core';
import { Watchlist } from '@libs/api-reference';

type DeleteWatchlistDialogEmitsType = {
  (e: 'delete', id: string): void;
};

type DeleteWatchlistDialogPropsType = {
  watchlist: Watchlist;
};

const emit = defineEmits<DeleteWatchlistDialogEmitsType>();

defineProps<DeleteWatchlistDialogPropsType>();

const { remove } = useDialog();

const { t } = useI18n();
</script>
